import {
    fetchRoute,
    initFieldValidation,
    ResourceEdit,
    TextField,
    TFieldValidation,
    Typography,
    validateUrl
} from "@cakemail-org/ui-components-v2"
import { OptInPolicy } from "../optInPolicy/OpinPolicy"
import { Trans, useTranslation } from "react-i18next"
import { Stack } from "@mui/material"
import { ChangeEvent, useState } from "react"
import { TFromCommonResourceEdit } from "./types"
import { ERoutes } from "../../../utils/url"

export function FromCommonResourceEdit({ form, saveForm }: TFromCommonResourceEdit) {
    const [fieldStates, setFieldStates] = useState<Record<string, TFieldValidation>>({
        ...initFieldValidation("post_redirect_url", { value: form?.post_redirect_url }),
        ...initFieldValidation("double_opt_in_redirect_url", { value: form?.double_opt_in_redirect_url })
    })
    const { t } = useTranslation()

    /*
    const defaultUrls = buildDefaultUrls({ list: selectedList, account: genericWrapper.account, user: genericWrapper.user, form })
    if (formToSave.post_redirect_url === "" || formToSave.post_redirect_url?.includes("undefined") || (formToSave.list_id && formToSave.list_id != form?.list_id)) {
        formToSave.post_redirect_url = defaultUrls.post_redirect_url
    }

    if (formToSave.double_opt_in_redirect_url === "" || formToSave.double_opt_in_redirect_url?.includes("undefined") || (formToSave.list_id && formToSave.list_id != form?.list_id)) {
        formToSave.double_opt_in_redirect_url = defaultUrls.double_opt_in_redirect_url
    }
    */


    function handleOptInPolicyChange(event: ChangeEvent<HTMLInputElement>, value: string) {
        saveForm({ double_opt_in: value === "dOptIn" })
    }

    function handleRedirectionChangeTimeout(event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const { name, value } = event.target

        const valueStatus = validateUrl(value)

        setFieldStates({
            ...fieldStates,
            [name]: valueStatus
        })

        if (!valueStatus.error) {
            saveForm({ [name]: value })
        }
    }

    const isDefaultPostUrl = form?.post_redirect_url === "" || form?.post_redirect_url?.includes(fetchRoute({ route: ERoutes.listSubscription }))
    const isDefaultDoptInUrl = form?.double_opt_in_redirect_url === "" || form?.double_opt_in_redirect_url?.includes(fetchRoute({ route: ERoutes.listConfirmation }))

    return <>
        <ResourceEdit
            editable
            status="valid"
            title={t("general-opt-in-settings")}
            desc={t("form-opt-in-desc")}
            support={<Typography variant="body1"><Trans i18nKey={form.double_opt_in ? "form-opt-in-support-enabled" : "form-opt-in-support-disabled"} /></Typography>}
            editableContent={<OptInPolicy initIsDOptIn={form.double_opt_in} onChange={handleOptInPolicyChange} />}
        />

        <ResourceEdit
            editable
            status={
                fieldStates.post_redirect_url.error || fieldStates.double_opt_in_redirect_url.error ? "error" : "valid"
            }
            title={t("general-redirection_other")}
            desc={t("forms-details-redirections-desc")}
            support={<Stack gap={2}>
                <Typography variant="body1">{t("form-post-redirect-url-desc", { url: isDefaultPostUrl ? t("general-default") : form.post_redirect_url })}</Typography>
                <Typography variant="body1">{t("form-dOpt-in-redirect-url-desc", { url: isDefaultDoptInUrl ? t("general-default") : form.double_opt_in_redirect_url })}</Typography>
            </Stack>}
            editableContent={<Stack gap={6}>
                <TextField
                    name="post_redirect_url"
                    label={t("form-post-redirect-url-label")}
                    placeholder={t("general-url-placeholder")}
                    defaultValue={isDefaultPostUrl ? "" : form.post_redirect_url}
                    timeout={{
                        callback: handleRedirectionChangeTimeout
                    }}
                    helperText={fieldStates.post_redirect_url.error && t(fieldStates.post_redirect_url.message || "")}
                    error={fieldStates.post_redirect_url.error}
                />
                <TextField
                    name="double_opt_in_redirect_url"
                    label={t("form-dOpt-in-redirect-url-label")}
                    placeholder={t("general-url-placeholder")}
                    defaultValue={isDefaultDoptInUrl ? "" : form.double_opt_in_redirect_url}
                    timeout={{
                        callback: handleRedirectionChangeTimeout
                    }}
                    helperText={fieldStates.double_opt_in_redirect_url.error && t(fieldStates.double_opt_in_redirect_url.message || "")}
                    error={fieldStates.double_opt_in_redirect_url.error}
                />
            </Stack>}
        />
    </>
}